import { apiPost } from '../../api'

export const save_asset = data => {
  return apiPost({
    endpoint: 'asset/save_asset',
    data: data
  })
}
